import { render, staticRenderFns } from "./WhReturnDetail.vue?vue&type=template&id=a89c3edc"
import script from "./WhReturnDetail.vue?vue&type=script&lang=js"
export * from "./WhReturnDetail.vue?vue&type=script&lang=js"
import style0 from "./WhReturnDetail.vue?vue&type=style&index=0&id=a89c3edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports